import React from "react";
import Footer from "../../Components/Footer/Footer";
import Images from "../../utils/images";

const Journey = () => {
  return (
    <div>
      <div className="flex min-h-screen flex-col bg-white pt-10">
        <section className="mx-auto w-[95%] px-4 py-8">
          <div className="font-jost py-7 text-3xl">
            <p className="text-secondary pt-4 text-center text-2xl font-semibold uppercase">
              your vmb Journey
            </p>
            <div className="mx-auto w-[180px] border-b-2 border-yellow-400 pt-2" />
            {/* <div className="mx-auto flex justify-center pt-10 md:w-[450px] lg:hidden">
            <img
              src={Images.JOURNEY}
              alt="Illustration of the VMB Journey"
              className="max-w-full rounded-lg shadow-lg"
            />
          </div> */}
          </div>

          <div className="content font-jost flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
            <div className="flex flex-col gap-6 lg:w-1/2">
              <div className="rounded-2xl bg-white p-6 shadow-md">
                <p className="text-justify text-gray-700">
                  <b>📝 Step 1 : Sign Up</b>
                  <p>
                    Fill out a short form with basic details and receive a mail
                    to verify your contact details and get signed up
                  </p>
                  <br />
                </p>
              </div>

              {/* Step 2 */}
              <div className="rounded-2xl bg-white p-6 shadow-md">
                <p className="text-justify text-gray-700">
                  <b>📋 Step 2 Registration</b>
                  <p>
                    Login through the link provided in the email with your user
                    id and password Fill out your personal details, upload your
                    photograph to complete your registration.
                  </p>
                </p>
              </div>

              {/* Step 3 */}
              <div className="rounded-2xl bg-white p-6 shadow-md">
                <p className="text-justify text-gray-700">
                  <b className="pb-5">Step 3 Active User </b>
                  <p>
                    When you complete the questionnaire you become an active
                    user.
                  </p>
                  <p>
                    ( We recommend you answer the questionnaire for your own
                    benefit you can find guidelines how to fill the same and
                    hear testimonials of those who have filled it )
                  </p>
                  <p>✅ VMB will send 3 reminders to complete the above</p>
                </p>
              </div>
              {/* Step 4 */}
              <div className="rounded-2xl bg-white p-6 shadow-md">
                <p className="text-justify text-gray-700">
                  <b className="pb-5">🔍 Step 4 : Explore & Propose</b>
                  <p>
                    ✨ If you are registered and active, you may explore
                    suitable matches and view their devotional and personal
                    expectations. A maximum of 5 proposals may be active at a
                    time, and even if all are accepted, you may proceed with
                    only one proposal of your choice.
                  </p>
                  <p>
                    ✨ Our matchmakers may also share suitable proposals with
                    you based on compatibility and expectations.
                  </p>
                </p>
              </div>
            </div>

            {/* <div className="hidden justify-center lg:flex lg:w-1/3">
            <img
              src={Images.JOURNEY}
              alt="Illustration of the VMB Journey"
              className="max-w-full rounded-lg shadow-lg"
            />
          </div> */}

            <div className="flex flex-col gap-6 lg:w-1/2">
              <div className="rounded-2xl bg-white p-6 shadow-md">
                <p className="text-justify text-gray-700">
                  <b>🔎 Step 5: Horoscope Matching </b>
                  <p>
                    🪐 Before proceeding to see full profile you are requested
                    to Match horoscopes (if it is important to you). Only after
                    confirmation from you the profile will be open for further
                    details , provided the proposed candidate also approves.
                  </p>
                  <p>Once mutual interest is confirmed:</p>
                  <p>
                    ✅ You can Independently verify backgrounds through mentor
                    whose contact will be visible
                  </p>
                </p>
              </div>

              <div className="rounded-2xl bg-white p-6 shadow-md">
                <p className="text-justify text-gray-700">
                  <b>📖 Step 6: Exchange Questionnaire Answers </b>
                  <p>
                    If both sides are satisfied and willing to proceed, they can
                    send questionnaire request and with consent from both
                    candidates VMB will exchange answers to questionnaire.
                  </p>
                </p>
              </div>
              <div className="rounded-2xl bg-white p-6 shadow-md">
                <p className="text-justify text-gray-700">
                  <b>📞 Step 7: Exchange Contact Info</b>
                  <p>
                    When both parties are ready to move forward after going
                    through the answers to questionnaire they must inform VMB
                  </p>
                  <p>
                    📲 VMB will share your contact numbers so you can connect
                    directly!
                  </p>
                  <p>🌟 Ready to Begin Your Journey with VMB? Start Today</p>
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Journey;
